"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const theme_1 = require("../../components/theme");
exports.CSS = {
    container: 'c-MeasurementPopup',
    header: 'c-MeasurementPopup__header',
    title: 'c-MeasurementPopup__title',
    headerActions: 'c-MeasurementPopup__headerActions',
    pauseButton: 'c-MeasurementPopup__pauseButton',
    closeButton: 'c-MeasurementPopup__closeButton',
    content: 'c-MeasurementPopup__content',
    emptyState: 'c-MeasurementPopup__emptyState',
    measurementRow: 'c-MeasurementPopup__measurementRow',
    measurementLabel: 'c-MeasurementPopup__measurementLabel',
    measurementValue: 'c-MeasurementPopup__measurementValue',
};
exports.Style = {
    [exports.CSS.container]: {
        position: 'absolute',
        bottom: theme_1.DefaultTheme.space(2),
        left: '50%',
        transform: 'translateX(-50%)',
        background: '#ffffff',
        boxShadow: theme_1.DefaultTheme.shadow.box.dp4,
        borderRadius: '8px',
        minWidth: '300px',
        maxWidth: '400px',
    },
    [exports.CSS.header]: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: `${theme_1.DefaultTheme.space(2)} ${theme_1.DefaultTheme.space(3)}`,
        borderBottom: `1px solid ${theme_1.DefaultTheme.font.color.divider}`,
    },
    [exports.CSS.title]: {
        fontSize: '16px',
        fontWeight: 600,
        color: theme_1.DefaultTheme.font.color.primary,
    },
    [exports.CSS.headerActions]: {
        display: 'flex',
        alignItems: 'center',
        gap: theme_1.DefaultTheme.space(1),
    },
    [exports.CSS.pauseButton]: {
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        padding: `${theme_1.DefaultTheme.space(0.5)} ${theme_1.DefaultTheme.space(1)}`,
        fontSize: '13px',
        color: theme_1.DefaultTheme.font.color.supporting,
        borderRadius: '4px',
        transition: 'background-color 0.15s',
        '&:hover': {
            backgroundColor: theme_1.DefaultTheme.font.color.divider,
            color: theme_1.DefaultTheme.font.color.primary,
        },
    },
    [exports.CSS.closeButton]: {
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        padding: theme_1.DefaultTheme.space(1),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: theme_1.DefaultTheme.font.color.supporting,
        '&:hover': {
            color: theme_1.DefaultTheme.font.color.primary,
        },
    },
    [exports.CSS.content]: {
        padding: `${theme_1.DefaultTheme.space(2)} ${theme_1.DefaultTheme.space(3)}`,
    },
    [exports.CSS.emptyState]: {
        color: theme_1.DefaultTheme.font.color.supporting,
        fontSize: '14px',
        textAlign: 'center',
        padding: theme_1.DefaultTheme.space(2),
    },
    [exports.CSS.measurementRow]: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: `${theme_1.DefaultTheme.space(0.5)} 0`,
    },
    [exports.CSS.measurementLabel]: {
        color: theme_1.DefaultTheme.font.color.supporting,
        fontSize: '13px',
    },
    [exports.CSS.measurementValue]: {
        color: theme_1.DefaultTheme.font.color.primary,
        fontSize: '13px',
        fontWeight: 500,
    },
};
//# sourceMappingURL=measurement.popup.style.js.map